import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { DNABox, DNAButton, Hoverable, Iffy, luxColors } from '@alucio/lux-ui';

const styles = StyleSheet.create({
  overlay: {
    alignItems: 'center',
    backgroundColor: luxColors.opacityBackground.primary,
    height: '100%',
    justifyContent: 'center',
    position: 'absolute',
    width: '100%',
  },
  presentButton: {
    alignItems: 'center',
    backgroundColor: luxColors.thumbnailBorder.primary,
    borderRadius: 50,
    height: 45,
    justifyContent: 'center',
    paddingLeft: 15,
    paddingRight: 15,
    width: 100,
  },
  presentText: {
    color: luxColors.tag.primary,
    fontSize: 15,
    fontWeight: 'bold',
  },
});

interface Props {
  showPresentHover?: boolean;
  itemHeight: number;
  onPresent?: () => void;
  onPreview?: () => void;
  showPreview: boolean;
}

const Wrapper: React.FC<Props> = (props) => {
  const { children, itemHeight, onPresent, onPreview, showPreview } = props;
  const [isHovered, setIsHovered] = useState<boolean>(false);

  function toggleHover(): void {
    setIsHovered(!isHovered);
  }

  if (!props.showPresentHover) {
    return <>{children}</>;
  }

  return (
    <Hoverable onHoverIn={toggleHover} onHoverOut={toggleHover}>
      <View>
        {children}
        <Iffy is={isHovered}>
          <DNABox spacing="small" appearance="col" style={[styles.overlay, { height: itemHeight + 4 }]}>
            <DNAButton
              size="small"
              iconLeft="play"
              onPress={onPresent}
            >
              Present
            </DNAButton>
            <Iffy is={!!showPreview}>
              <DNAButton
                size="small"
                appearance="filled"
                iconLeft="eye-outline"
                onPress={onPreview}
                status="flat"
              >
                Preview
              </DNAButton>
            </Iffy>
          </DNABox>
        </Iffy>
      </View>
    </Hoverable>
  );
};

export default Wrapper;
